var map = {
	"./q5-1-1@2x.png": "eb0e",
	"./q5-1-2@2x.png": "9928",
	"./q5-1-3@2x.png": "1e0b",
	"./q5-1-4@2x.png": "0d35",
	"./q5-1-5@2x.png": "ecc2",
	"./q5-1-6@2x.png": "d7f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd6d";